import { render, staticRenderFns } from "./LookingToInvest.vue?vue&type=template&id=70980a68&scoped=true&"
import script from "./LookingToInvest.vue?vue&type=script&lang=ts&"
export * from "./LookingToInvest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70980a68",
  null
  
)

export default component.exports